import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "alt", "tabIndex", "role"]

export function render(_ctx, _cache) {
  const _component_ImageSpinner = _resolveComponent("ImageSpinner")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.getClass('image') + ' ' + ((_ctx.isLoaded != null && _ctx.isLoaded) ? _ctx.getClass('loaded') : '')),
    onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.onElClick && _ctx.onElClick(...args)))
  }, [
    _createVNode(_Transition, { name: "satisfi_fade2" }, {
      default: _withCtx(() => [
        (!_ctx.isLoaded)
          ? (_openBlock(), _createBlock(_component_ImageSpinner, {
              key: 0,
              class: _normalizeClass(_ctx.getClass('image__spinner'))
            }, null, 8 /* PROPS */, ["class"]))
          : _createCommentVNode("v-if", true)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("img", {
      src: _ctx.component.imageUrl,
      alt: _ctx.component.alt || 'IMAGE',
      tabIndex: _ctx.enableMessageNavigation ? 0 : -1,
      loading: "lazy",
      style: {"height":"auto","width":"100%"},
      onLoad: _cache[0] || (_cache[0] = (...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
      onError: _cache[1] || (_cache[1] = (...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
      role: _ctx.enableMessageNavigation ? 'img' : null,
      class: _normalizeClass(_ctx.isFirefoxSVGClass ? _ctx.getClass('firefox-svg') : '')
    }, null, 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_1)
  ], 2 /* CLASS */))
}